import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const PriceTicker = ({ className = '' }) => {
  const [btcPrice, setBtcPrice] = useState(94707);
  const [ethPrice, setEthPrice] = useState(3245.67);
  const [btcChange, setBtcChange] = useState(0);
  const [ethChange, setEthChange] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchPrices = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/crypto/prices`);
      const data = await response.json();
      
      if (data.success) {
        const oldBtc = btcPrice;
        const oldEth = ethPrice;
        
        setBtcPrice(data.prices.BTC.price);
        setEthPrice(data.prices.ETH.price);
        
        setBtcChange(((data.prices.BTC.price - oldBtc) / oldBtc * 100).toFixed(2));
        setEthChange(((data.prices.ETH.price - oldEth) / oldEth * 100).toFixed(2));
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching crypto prices:', error);
      setLoading(false);
    }
  };

  return (
    <div className={`bg-[#E8F4FD] border border-[#006AFF]/20 rounded-lg px-4 py-2 ${className}`}>
      <div className="flex items-center justify-center space-x-6 text-sm">
        <div className="flex items-center space-x-2">
          <span className="text-[#6B6B76]">BTC:</span>
          <span className="text-[#2A2A33] font-semibold">${btcPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          {btcChange > 0 ? (
            <span className="flex items-center text-green-600 text-xs">
              <TrendingUp className="h-3 w-3 mr-1" />
              {btcChange}%
            </span>
          ) : btcChange < 0 ? (
            <span className="flex items-center text-red-500 text-xs">
              <TrendingDown className="h-3 w-3 mr-1" />
              {Math.abs(btcChange)}%
            </span>
          ) : null}
        </div>
        <div className="h-6 w-px bg-[#006AFF]/20"></div>
        <div className="flex items-center space-x-2">
          <span className="text-[#6B6B76]">ETH:</span>
          <span className="text-[#2A2A33] font-semibold">${ethPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          {ethChange > 0 ? (
            <span className="flex items-center text-green-600 text-xs">
              <TrendingUp className="h-3 w-3 mr-1" />
              {ethChange}%
            </span>
          ) : ethChange < 0 ? (
            <span className="flex items-center text-red-500 text-xs">
              <TrendingDown className="h-3 w-3 mr-1" />
              {Math.abs(ethChange)}%
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PriceTicker;
